import { CurrencyPipe, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class PricingStructureTemplateService {
  url :string = environment.url;

  curPipe :CurrencyPipe;
  datePipe :DatePipe;

  private readonly _templates = new BehaviorSubject<any>(<any>[]);
  public templates$ = this._templates.asObservable();

  private readonly _pricingStructureItems = new BehaviorSubject<any>(<any>[]);
  public pricingStructureItems$ = this._pricingStructureItems.asObservable();

  private readonly _clientTemplate = new BehaviorSubject<any>(<any>[]);
  public clientTemplate$ = this._clientTemplate.asObservable();

  public gettingRecords :boolean = false;

  private params :any = {
    per_page: 20,
    page: 1,
  };

  constructor(private http :HttpClient) {}

  getPricingStructureTemplates(params) {
    this.gettingRecords = true;

    return this.http
      .get(`${this.url}/pricing-structure-template`, { params: params })
      .subscribe((resp :any) => {
        this.gettingRecords = false;
        this._templates.next(resp);
      });
  }

  getPricingStructureItems() :Observable<any> {
    this.gettingRecords = true;

    return this.http.get(`${this.url}/pricing-structure-items`);
  }

  refreshList() {
    this.getPricingStructureTemplates(this.params);
  }

  setParams(params :any) {
    this.params = params;
  }

  saveTemplate(payload :any) :Observable<any> {
    return this.http.post(`${this.url}/pricing-structure-template`, payload).pipe(
      tap((resp :any) => {
        setTimeout(() => {
          const templates :any = this._templates.getValue();
          if (templates && templates.data) {
            templates.data.splice(0, 0, resp);
            this._templates.next(templates);
          }
        });
      }),
    );
  }

  updateTemplate(payload :any, templateId :number) {
    return this.http
      .put(`${this.url}/pricing-structure-template/${templateId}`, payload)
      .pipe(
        tap((resp :any) => {
          this.tryUpdateOrAddResp(resp);
        }),
      );
  }

  deleteTemplate(templateId :number) {
    return this.http
      .delete(`${this.url}/pricing-structure-template/${templateId}`)
      .pipe(
        tap((resp :any) => {
          const templates :any = this._templates.getValue();
          const templateIndex = templates.data.findIndex(
            (row) => row.id == templateId,
          );
          templates.data.splice(templateIndex, 1);
          this._templates.next(templates);
        }),
      );
  }

  tryUpdateOrAddResp(resp) {
    const templates :any = this._templates.getValue();
    if (!templates || !templates.data) {
      return;
    }
    const templateIndex = templates.data.findIndex((row) => row.id == resp.id);

    templates.data[templateIndex] = resp;

    this._templates.next(templates);
  }

  selectTemplate(payload :any) {
    return this.http.post(`${this.url}/client-pricing-structure-setting`, payload);
  }

  loadClientTemplate(clientId) {
    return this.http
      .get(`${this.url}/client-pricing-structure-setting`, {
        params: { client_id: clientId },
      })
      .subscribe((resp :any) => {
        this.gettingRecords = false;
        this._clientTemplate.next(resp);
      });
  }

  massAssignTemplate(payload :any) {
    return this.http.post(`${this.url}/mass-assign-template`, payload);
  }
}
